import FixedArray from './fixedArray';

export const lastUsedStoreIdCache = new FixedArray<string>(20, true);
export const lastUsedExternalStoreIdCache = new FixedArray<string>(20, true);
